import script from "./EditProjectModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditProjectModal.vue?vue&type=script&setup=true&lang=ts"

import "./EditProjectModal.vue?vue&type=style&index=0&id=46a11c59&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46a11c59"]])

export default __exports__